var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCssLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 99,
    viewBox: "0 0 75 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9458 0H29.5801V4.44675H23.3926V8.8935H29.5801V13.3403H18.9458V0Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7043 0H42.3427V3.86925H36.1552V4.64062H42.3427V13.5341H31.7043V9.47512H37.8918V8.69963H31.7043V0Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4712 0H55.1013V3.86925H48.9138V4.64062H55.1013V13.5341H44.4712V9.47512H50.6587V8.69963H44.4712V0Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4629 99.0001L8.81887 91.0471L0.375 19.4578H74.625L66.1852 91.0389L37.4629 99.0001ZM17.0689 51.8638L17.8568 60.6418H48.2869L47.268 72.0268L37.4753 74.675H37.467L27.6907 72.035L27.0638 65.0349H18.2486L19.4779 78.8206L37.4629 83.8119L55.4767 78.8206L57.6712 54.2191L57.8857 51.8638L59.4697 34.0891H15.489L16.2892 42.8713H49.8503L49.05 51.8638H17.0689Z",
    fill: "#278AE5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_67"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 99,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCssLogo);
export default __webpack_public_path__ + "static/media/css_logo.8f0ddae7d6085d8bfba148d74fc59d25.svg";
export { ForwardRef as ReactComponent };